  import { ApiListResponse, ApiResponse } from "@/types/api-response.model";
  import { AttendanceData, AttendanceFilter, AttendanceTodayData, CreateAttendanceDto } from "@/types/attendance.interfaces";
  import { HttpClient, HttpParams } from "@angular/common/http";
  import { inject, Injectable } from "@angular/core";
  import { Observable } from "rxjs";

  @Injectable({ providedIn: 'root' })
  export class AttendanceService {
    private http = inject(HttpClient);
    private readonly apiUrl = `/api/attendance`;

    getAllAttendance(filters?: AttendanceFilter): Observable<ApiListResponse<AttendanceData>> {
      let params = new HttpParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            params = params.set(key, value.toString());
          }
        });
      }

      return this.http.get<ApiListResponse<AttendanceData>>(this.apiUrl, { params });
    }

    getTodayStatus(): Observable<ApiResponse<AttendanceTodayData>> {
      return this.http.get<ApiResponse<AttendanceTodayData>>(`${this.apiUrl}/today`);
    }

    manualCheckin(data: FormData): Observable<ApiResponse<AttendanceData>> {
      return this.http.post<ApiResponse<AttendanceData>>(`${this.apiUrl}/checkin/manual`, data);
    }

    manualCheckout(data: FormData): Observable<ApiResponse<AttendanceData>> {
      return this.http.post<ApiResponse<AttendanceData>>(`${this.apiUrl}/checkout/manual`, data);
    }

    getDetailById(id: string): Observable<ApiResponse<AttendanceData>> {
      return this.http.get<ApiResponse<AttendanceData>>(`${this.apiUrl}/${id}`);
    }

    updateAttendanceStatus(id: string, status: string, adminId: string): Observable<ApiResponse<AttendanceData>> {
      return this.http.patch<ApiResponse<AttendanceData>>(`${this.apiUrl}/${id}`, {
        status,
        manualBy: adminId
      });
    }


  }
